import { useEffect, useRef } from 'react';

export function useDraftCommitGuards(flush: () => void) {
  const flushRef = useRef(flush);

  useEffect(() => {
    flushRef.current = flush;
  }, [flush]);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const commit = () => {
      try {
        flushRef.current();
      } catch {
        /* ignore */
      }
    };
    const onVisibility = () => {
      if (document.visibilityState !== 'visible') commit();
    };

    // covers iOS swipe-back / leaving page
    window.addEventListener('pagehide', commit);
    // SPA back/forward
    window.addEventListener('popstate', commit);
    // tab/background switch
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      window.removeEventListener('pagehide', commit);
      window.removeEventListener('popstate', commit);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);
}
